import { render } from "./accordionComponent.vue?vue&type=template&id=30f08f1c&scoped=true"
import script from "./accordionComponent.vue?vue&type=script&lang=js"
export * from "./accordionComponent.vue?vue&type=script&lang=js"

import "./accordionComponent.vue?vue&type=style&index=0&id=30f08f1c&lang=scss&scoped=true"

import exportComponent from "../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30f08f1c"],['__file',"cartridges/int_guidedProductFinder/cartridge/client/default/js/components/accordion/accordionComponent.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "30f08f1c"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('30f08f1c', __exports__)) {
    api.reload('30f08f1c', __exports__)
  }
  
  module.hot.accept("./accordionComponent.vue?vue&type=template&id=30f08f1c&scoped=true", () => {
    api.rerender('30f08f1c', render)
  })

}


export default __exports__